import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_regularly_test_service_fire_extinguishers_other'

export const dataPointDefinition = {
  retracedId: 'does_facility_regularly_test_service_fire_extinguishers_other',
  name: 'Does the facility regularly test and service fire extinguishers and other firefighting equipment in line with legal requ',
  description:
    'Other firefighting equipment includes, but are not limited to, fire hose and connections, sprinklers, etc.',
  meta: {
    slcpMeta: {
      key: 'hs-20--3-4x',
      number: 'HS-EME-9',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-20--3-4x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29220,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
